export const getUploadFileName = (file: string) => {
  const fileName = file.slice(0, -4);
  const timeStamp = new Date().getTime();
  return `${fileName}-${timeStamp}.csv`;
};
